export function routes($stateProvider) {
    $stateProvider
        .state('app.formacao.testemunhos', {
        url: '/testemunhos',
        abstract: true,
        template: '<div ui-view></div>'
    })
        .state('app.formacao.testemunhos.list', {
        url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
        title: 'Testemunhos',
        template: require('./directory/directory.view.html'),
        controller: 'ForListTestemunhosController',
        controllerAs: 'vm',
        role: 'formacaoVerTestemunhos',
        params: {
            state: {
                value: 1,
                dynamic: true
            },
            page: {
                value: 1,
                dynamic: true
            },
            items: {
                value: 20,
                dynamic: true
            },
            order: {
                value: "id",
                dynamic: true
            },
            sort: {
                value: "desc",
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    });
}
routes.$inject = ['$stateProvider'];
